import { composeDataModules } from '@perpay-web/data-module/composeDataModules';
import { fetchUserInfoDataModule } from '@perpay-web/fintech/dataModules/fetchUserInfo';
import { partnerHostedCardApplicationDataModule } from '@perpay-web/fintech/dataModules/partnerHostedCardApplication';
import { useMetalCardABTestAdapter } from '@perpay-web/hooks/abTests/useMetalCardABTest';

const PartnerOnboardingDataModule = composeDataModules([
    partnerHostedCardApplicationDataModule,
    fetchUserInfoDataModule,
    useMetalCardABTestAdapter,
]);

const getRoot = (state) => state.dataModules.partnerOnboarding;

export const partnerOnboardingDataModule = PartnerOnboardingDataModule({
    getRoot,
    key: 'PARTNER_ONBOARDING',
});
